import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { ReplaySubject, Subject } from 'rxjs/';

import { CommunicationService } from './communication.service';
import { User } from '../models/user';
import { BasicError, Error403 } from '../models/error/error';

@Injectable()
export class UserService {
  private allUsersUrl = '/api/v1/users';
  private userDetailUrl = '/api/v1/users/';
  private allUsersReplay = null;

  constructor(private communication: CommunicationService) { }

  /**
   * This function gets all Users from the api.
   * @param currentPage
   */
  public getAllUsers(currentPage: number = 1): Subject<any> {
    if (this.allUsersReplay === null) {
      this.allUsersReplay = new Subject();
    } else if (currentPage === 1) {
      return this.allUsersReplay;
    }

    const request = this.communication.get(this.allUsersUrl + '?page=' + currentPage + '&limit=0');
    request.subscribe(json => {
      // Check if an Error occured
      if (json instanceof BasicError) {
        console.log('---UserService---: User is not authorized to get all Users.');
        this.allUsersReplay.next(json);
        this.allUsersReplay = null;
        return;
      }

      // No Error occured
      const total: number = json.meta.pagination.total_pages;
      const ret = [];

      // Getting all Users
      for (let i = 0; i < json.data.length; i++) {
        const js = json.data[i];
        const user = new User(js.id);

        if (js.attributes.name) { user.setName(js.attributes.name) };
        if (js.attributes.email) { user.setEmail(js.attributes.email) };
        if (js.attributes.firstname) { user.setFirstName(js.attributes.firstname) };
        if (js.attributes.lastname) { user.setLastName(js.attributes.lastname) };
        if (js.attributes.picture) { user.setPicture(js.attributes.picture) };
        if (js.attributes.role) { user.setRole(js.attributes.role) };
        if (js.attributes.sex) {
          switch (js.attributes.sex) {
            case 1: user.setSex('männlich');
              break;
            case 2: user.setSex('weiblich');
              break;
            default: user.setSex('neutral');
          }
        }

        ret.push(user);
      }

      if (currentPage >= total) {
        this.allUsersReplay.next(ret);
        this.allUsersReplay = null;
      } else {
        this.allUsersReplay.next(ret);
        this.getAllUsers((currentPage + 1));
      }
    });

    return this.allUsersReplay;
  }

  /**
   * This function get's the user data of a specified user (by id)
   * @param userId userId of user to get data of
   */
  public getUserDetails(userId: Number): Subject<any> {
    const retReplay = new Subject();

    this.communication.get(this.userDetailUrl.toString() + userId).subscribe(json => {
      if (json instanceof BasicError) {
        console.log('--------UserService-------: Failed to return User details');
        retReplay.next(json);
        return;
      }

      // User details returned now get data
      const id: String = json.data.id;
      const name: String = (json.data.attributes.name) ? json.data.attributes.name : '';
      const firstname: String = (json.data.attributes.firstname) ? json.data.attributes.firstname : '';
      const lastname: String = (json.data.attributes.lastname) ? json.data.attributes.lastname : '';

      const user: User = new User(id, name, firstname, lastname);

      // Getting other parameters into user object
      if (json.data.attributes.email) {
        user.setEmail(json.data.attributes.email);
      }

      /* if (json.data.attributes.sex) {
        user.setSex(json.data.attributes.sex);
      } */

      if (json.data.attributes.sex) {
        switch (json.data.attributes.sex) {
          case 1: user.setSex('männlich');
            break;
          case 2: user.setSex('weiblich');
            break;
          default: user.setSex('neutral');
        }
      }

      if (json.data.attributes.picture) {
        user.setPicture(json.data.attributes.picture);
      }

      if (json.data.attributes.settings) {
        user.setSettings(json.data.attributes.settings);
      }

      retReplay.next(user);
    });

    return retReplay;
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/services/user.service.ts